import { render, staticRenderFns } from "./masterdata-summary.container.vue?vue&type=template&id=27991b3e&scoped=true&lang=pug"
import script from "./masterdata-summary.container.vue?vue&type=script&lang=ts"
export * from "./masterdata-summary.container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27991b3e",
  null
  
)

export default component.exports